import { useRef, useState, } from 'react';
import { useTexture } from '@react-three/drei';
import { RepeatWrapping, DoubleSide, Vector2 } from 'three';
import BeachGeometry from './BeachGeometry';
import pebblesSeamless from '../../../assets/information/beach/Pebbles_021_4K_basecolor.jpg';
import pebblesNormalSeamless from '../../../assets/information/beach/Pebbles_021_4K_Normal.jpg';
import pebblesRoughnessSeamless from '../../../assets/information/beach/Pebbles_021_4K_Roughness.jpg';

const Beach = ({ currentOffset, targetOffset, }) => {
  const [repeat] = useState(new Vector2(12, 12));

  const pebblesTexture = useTexture(pebblesSeamless);
  const pebblesNormal = useTexture(pebblesNormalSeamless);
	const pebblesRoughness = useTexture(pebblesRoughnessSeamless);

  const mesh = useRef();
  const map = useRef();
  const normalMap = useRef();
  const roughnessMap = useRef();

  return (
    <group>
      <mesh
        scale={[1, 1, 1]}
        rotation={[Math.PI / 2, 0, 0]}
        position={[0, -8, 0]}
        ref={mesh}
        onPointerMove={(e) => {
					const x = e.pointer.x / window.innerWidth;
					const y = e.pointer.y / window.innerHeight;

					targetOffset.current.set(x, y);

					e.stopPropagation();
        }}
      >
        {/* <Suspense fallback={null}> */}
          <meshPhysicalMaterial
            attach='material'
            color={'white'}
            roughness={0}
            reflectivity={0.0}
            side={DoubleSide}
            needsUpdate={true}
          >
            <primitive
              object={pebblesTexture}
              ref={map}
              attach={`map`}
              wrapS={RepeatWrapping}
              wrapT={RepeatWrapping}
              repeat={repeat}
              needsUpdate={true}
            />
            <primitive
              object={pebblesNormal}
              ref={normalMap}
              attach={`normalMap`}
              wrapS={RepeatWrapping}
              wrapT={RepeatWrapping}
              repeat={repeat}
            />
            <primitive
              object={pebblesRoughness}
              ref={roughnessMap}
              attach={`roughnessMap`}
              wrapS={RepeatWrapping}
              wrapT={RepeatWrapping}
              repeat={repeat}
            />
          </meshPhysicalMaterial>
        {/* </Suspense> */}
        <BeachGeometry />
      </mesh>
    </group>
  );
};

export default Beach;
